(function () {
  // ======= CONFIG =======
  const PROXY_PATH = "/apps/cazati/measure_create_variant.php";

  const cfg = window.fabricMeasurementConfig || {};
  const sectionId = cfg.sectionId;
  const pricePerSqm = Number(cfg.pricePerSqm || 0);
  const productId = String(cfg.productId || "");

  let addingCustomNow = false;
  let lockPrice = false;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function formatPriceBRL(v) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(v || 0));
  }

  function parseNumBR(v) {
    if (typeof v !== "string") v = String(v ?? "");
    return parseFloat(v.replace(",", ".")) || 0;
  }

  async function parseJSONSafe(resp) {
    try {
      return await resp.json();
    } catch (e) {
      const txt = await resp.text();
      try {
        return JSON.parse(txt);
      } catch {
        return { raw: txt };
      }
    }
  }

  // === VERSÃO OTIMIZADA: Oculta variantes "Sob Medida - ..." de forma mais sutil
  function hideGeneratedSobMedidaVariants() {
    // Procura por inputs radio com valores que começam com "Sob Medida - "
    document.querySelectorAll('input[name="tamanho"], input[name*="options"]').forEach((input) => {
      const value = (input.value || "").trim();
      
      // Se o valor começar com "Sob Medida - " (com hífen e espaço)
      if (/^Sob Medida\s*-\s*.+/i.test(value)) {
        // Oculta o input
        input.style.display = "none";
        input.style.visibility = "hidden";
        input.disabled = true;
        
        // Encontra e oculta o label correspondente
        const label = document.querySelector(`label[for="${input.id}"]`) || 
                     input.closest("label") ||
                     input.parentElement.querySelector("label");
        
        if (label) {
          label.style.display = "none";
          label.style.visibility = "hidden";
        }
        
        // Se o input estiver dentro de um container específico, oculta o container
        const container = input.closest('.m-product-option__item, .variant-option, .product-option');
        if (container) {
          container.style.display = "none";
          container.style.visibility = "hidden";
        }
      }
    });

    // Procura por options em selects
    document.querySelectorAll('select[name="id"] option, select[name*="options"] option').forEach((option) => {
      const text = (option.textContent || option.value || "").trim();
      
      if (/^Sob Medida\s*-\s*.+/i.test(text)) {
        option.style.display = "none";
        option.disabled = true;
        // Remove da lista para evitar seleção acidental
        option.remove();
      }
    });

    // Procura por labels que contenham o padrão diretamente
    document.querySelectorAll('label').forEach((label) => {
      const text = (label.textContent || "").trim();
      
      if (/^Sob Medida\s*-\s*.+/i.test(text)) {
        // Verifica se não é um label de um input já processado
        const associatedInput = label.getAttribute('for') ? 
          document.getElementById(label.getAttribute('for')) : 
          label.querySelector('input');
        
        if (!associatedInput || !associatedInput.style.display) {
          label.style.display = "none";
          label.style.visibility = "hidden";
        }
      }
    });
  }

  function initialize() {
    const productForm = document.getElementById("MainProduct-" + sectionId);
    if (!productForm) return;

    const wrapper = document.getElementById("fabric-measurement-wrapper-" + sectionId);
    if (!wrapper) return;

    const widthInput = wrapper.querySelector("[data-fabric-width]");
    const lengthInput = wrapper.querySelector("[data-fabric-length]");
    const totalAreaDisplay = wrapper.querySelector("[data-total-area]");
    const totalPriceDisplay = wrapper.querySelector("[data-total-price]");

    const finishingInputs = wrapper.querySelectorAll("[data-fabric-finishing]");
    const propFinishing = document.querySelector("[data-prop-finishing]");

    const mainPriceElement =
      document.querySelector("#Price-" + sectionId) ||
      document.querySelector("#Price-template--17054548590653__main");

    const addBtn =
      productForm.querySelector('button[name="add"]') ||
      productForm.querySelector('[type="submit"]');

    let isCustomVariantSelected = false;

    function recalcAndPaint() {
      if (!isCustomVariantSelected) return;

      const width = parseNumBR(widthInput.value);
      const length = parseNumBR(lengthInput.value);
      const area = width * length;
      let totalPrice = area * pricePerSqm;

      // Verifica acabamento selecionado
      let finishing = "overlock";
      finishingInputs.forEach((input) => {
        if (input.checked) finishing = input.value;
      });

      // Aplica acréscimo de 20%
      if (finishing === "barra") {
        totalPrice *= 1.2;
      }

      const propFormat = document.querySelector("[data-prop-format]");

      const selectedFormat = wrapper.querySelector('[data-fabric-format]:checked')?.value;
      const selectedShape = wrapper.querySelector('[data-organic-shape]:checked')?.value;
      

      if (propFormat) {
        if (selectedFormat === 'organico') {
          propFormat.value = selectedShape ? `Orgânico - ${selectedShape}` : "Orgânico";
        } else {
          propFormat.value = "Normal";
        }
      }

      if (selectedFormat === 'organico') {
        totalPrice *= 1.25;
      }

      totalAreaDisplay.textContent = area > 0 ? area.toFixed(2) + " m²" : "0.00 m²";
      totalPriceDisplay.textContent = totalPrice > 0 ? formatPriceBRL(totalPrice) : formatPriceBRL(0);

      if (mainPriceElement && totalPrice > 0) {
        lockPrice = true;
        mainPriceElement.innerHTML = `<span class="price__current">${formatPriceBRL(totalPrice)}</span>`;
      } else if (mainPriceElement) {
        lockPrice = false;
      }

      if (propFinishing) {
        propFinishing.value = finishing === "barra" ? "Barra Virada (+20%)" : "Overlock";
      }

      finishingInputs.forEach((input) => {
        input.addEventListener("change", recalcAndPaint);
      });
    }

    function getSelectedVariantText() {
      const selectedRadio = productForm.querySelector('input[name^="tamanho"]:checked');
      if (selectedRadio) return String(selectedRadio.value || "").trim();

      const selectEl = productForm.querySelector('select[name="id"]');
      if (selectEl) {
        const opt = selectEl.options[selectEl.selectedIndex];
        return opt ? opt.textContent.trim() : "";
      }
      return "";
    }

    function handleVariantChange() {
      const value = getSelectedVariantText();

      // Mostra/oculta calculadora apenas para "Sob Medida" exato
      if (value && value.trim() === "Sob Medida") {
        isCustomVariantSelected = true;
        wrapper.style.display = "block";
        recalcAndPaint();
      } else {
        isCustomVariantSelected = false;
        wrapper.style.display = "none";
        lockPrice = false;
      }

      // Sempre executa a limpeza de variantes indesejadas
      hideGeneratedSobMedidaVariants();
    }

    // Intercepta submit
    productForm.addEventListener("submit", function (e) {
      if (!isCustomVariantSelected) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addCustomToCart().catch((err) => {
        console.error("[Fabric Measurement] ERRO:", err);
        alert("Erro ao adicionar ao carrinho: " + (err && err.message ? err.message : err));
      });
    }, true);

    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        if (!isCustomVariantSelected) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addCustomToCart().catch((err) => {
          console.error("[Fabric Measurement] ERRO:", err);
          alert("Erro ao adicionar ao carrinho: " + (err && err.message ? err.message : err));
        });
      }, true);
    }

    async function addCustomToCart() {
      if (addingCustomNow) return;
      addingCustomNow = true;

      try {
        if (!productId) throw new Error("ID do produto não encontrado.");

        const width = parseNumBR(widthInput.value);
        const length = parseNumBR(lengthInput.value);

        if (width <= 0 || length <= 0) {
          throw new Error("Por favor, informe a Largura e o Comprimento.");
        }

        const area = width * length;
        let totalPrice = area * pricePerSqm;

        // acabamento
        let finishing = "overlock";
        finishingInputs.forEach((input) => {
          if (input.checked) finishing = input.value;
        });

        const selectedFormat = wrapper.querySelector('[data-fabric-format]:checked')?.value;
        const selectedShape = wrapper.querySelector('[data-organic-shape]:checked')?.value;

        if (finishing === "barra") {
          totalPrice *= 1.2;
        }

        if (selectedFormat === 'organico') {
          totalPrice *= 1.25;
        }

        totalPrice = +totalPrice.toFixed(2);

        const resp = await fetch(PROXY_PATH, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId,
            width,
            length,
            price: totalPrice,
            optionName: "Sob Medida",
          }),
        });

        const payload = await parseJSONSafe(resp);
        if (!resp.ok || !payload) {
          throw new Error("Falha ao criar variante.");
        }

        const variantId = (payload.variant && payload.variant.id) || payload.variant_id || payload.id;

        if (!variantId) {
          console.warn("[Fabric Measurement] Resposta inesperada:", payload);
          throw new Error("ID da variante não retornado.");
        }

        const add = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: {
                  _sob_medida: "true",
                  "Largura (m)": width.toFixed(2),
                  "Comprimento (m)": length.toFixed(2),
                  "Área Total (m²)": area.toFixed(2),
                  "Preço por m²": formatPriceBRL(pricePerSqm),
                  "Valor calculado": formatPriceBRL(totalPrice),
                  "Acabamento": finishing === "barra" ? "Barra Virada (+20%)" : "Overlock",
                  "Formato": selectedFormat === 'organico' ? (selectedShape ? `Orgânico - ${selectedShape}` : "Orgânico") : "Normal",
                },
              },
            ],
          }),
        });

        if (!add.ok) {
          const err = await parseJSONSafe(add);
          throw new Error((err && (err.description || err.message)) || "Erro ao adicionar ao carrinho.");
        }

        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } finally {
        addingCustomNow = false;
      }
    }

    // Eventos para mudança de variante
    const variantInputs = productForm.querySelectorAll('input[name^="tamanho"][type="radio"]');
    variantInputs.forEach((input) => input.addEventListener("change", handleVariantChange));

    const selectEl = productForm.querySelector('select[name="id"]');
    if (selectEl) {
      selectEl.addEventListener("change", handleVariantChange);
    }

    // Tema Minimog dispara este evento custom
    document.addEventListener("variant:changed", handleVariantChange);

    widthInput && widthInput.addEventListener("input", recalcAndPaint);
    lengthInput && lengthInput.addEventListener("input", recalcAndPaint);

    handleVariantChange();
  }

  ready(() => {
    initialize();

    // Executa limpeza inicial
    hideGeneratedSobMedidaVariants();

    // Observador otimizado que monitora apenas mudanças relevantes
    const observer = new MutationObserver((mutations) => {
      let needsCleanup = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Verifica se foram adicionados elementos que podem conter variantes
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const hasVariantElements = node.querySelector && (
                node.querySelector('input[name="tamanho"]') ||
                node.querySelector('input[name*="options"]') ||
                node.querySelector('select[name="id"]') ||
                node.matches('input[name="tamanho"]') ||
                node.matches('input[name*="options"]') ||
                node.matches('select[name="id"]')
              );
              
              if (hasVariantElements) {
                needsCleanup = true;
              }
            }
          });
        }
      });
      
      if (needsCleanup) {
        // Pequeno delay para garantir que o DOM foi atualizado
        setTimeout(() => {
          hideGeneratedSobMedidaVariants();
        }, 50);
      }
    });

    // Observa apenas o container de variantes para melhor performance
    const variantContainer = document.querySelector('.m-product-option, form[action*="/cart/add"]');
    if (variantContainer) {
      observer.observe(variantContainer, {
        childList: true,
        subtree: true
      });
    }

    // Limpeza periódica mais espaçada para não afetar performance
    setInterval(() => {
      hideGeneratedSobMedidaVariants();
    }, 5000);
  });
})();

